// Webpack Imports

import * as bootstrap from 'bootstrap';





( function () {
	'use strict';

	jQuery('.crud-main .crud').addClass("active");
	jQuery('.crud-main .crud:not(.crud-item)').removeClass("active");
	
	jQuery('.crud-main .crud .table-title').click(function(){
		jQuery(this).closest(".crud").toggleClass('active');
	});

	// Focus input if Searchform is empty

	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {

		el.addEventListener( 'submit', function ( e ) {

			var search = el.querySelector( 'input' );

			if ( search.value.length < 1 ) {

				e.preventDefault();

				search.focus();

			}

		} );

	} );



	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers

	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );

	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {

		return new bootstrap.Popover( popoverTriggerEl, {

			trigger: 'focus',

		} );

	} );



	jQuery('#comp_selector').change(function(){

		var id = jQuery(this).val();

		document.location.href = "/?com="+id;

	});



	jQuery('.profile-menu').click(function(){

		jQuery(this).toggleClass('active');

	});
	
	

	

} )();



